import { CheckCircle, Trash2 } from "lucide-react";

import { Button } from "@design-lab/shared/ui";

type ImageUploadedDisplayProps = {
  imageUrl: string;
  onDelete: () => void;
};

export function ImageUploadedDisplay({ imageUrl, onDelete }: ImageUploadedDisplayProps) {
  return (
    <div className="flex flex-col items-center gap-2">
      <img
        src={imageUrl}
        alt="Uploaded image"
        className="size-32 rounded-lg object-contain sm:size-48 lg:size-60"
      />

      <div className="flex items-center gap-2">
        <CheckCircle className="size-6 text-blue-600" />
        <p className="py-1 text-sm font-normal leading-[20px] text-gray-900">
          Image uploaded successfully
        </p>
      </div>

      <Button
        data-testid="delete-image-button"
        variant="outline"
        size="sm"
        onPress={onDelete}
        className="h-10 w-[138px] gap-2.5 rounded-md border-[1.5px] border-gray-300 bg-white px-1 py-[7px] shadow-sm"
      >
        <Trash2 className="size-4 text-red-700" />
        Delete image
      </Button>
    </div>
  );
}
